/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { PhoneNumberDto } from './phone-number-dto';

/**
 * 
 * @export
 * @interface PublicAccessInfoDto
 */
export interface PublicAccessInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PublicAccessInfoDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicAccessInfoDto
     */
    formType: PublicAccessInfoDtoFormTypeEnum;
    /**
     * 
     * @type {PhoneNumberDto}
     * @memberof PublicAccessInfoDto
     */
    phoneNumberDto: PhoneNumberDto;
}

/**
    * @export
    * @enum {string}
    */
export enum PublicAccessInfoDtoFormTypeEnum {
    PatientRegistration = 'PATIENT_REGISTRATION',
    DoctorRegistration = 'DOCTOR_REGISTRATION',
    ReceiptOrder = 'RECEIPT_ORDER'
}



